import { AMPLITUDE_EVENTS } from './constants';

export const getRMGameLaunchedProps = (launchedFromModal = false) => ({
    event: AMPLITUDE_EVENTS.EVENTS.RM_GAME_LAUNCHED,
    gaEventCategory: AMPLITUDE_EVENTS.CATEGORIES.REWARDS_MACHINE,
    gaEventAction: AMPLITUDE_EVENTS.ACTIONS.CLICKED,
    module: AMPLITUDE_EVENTS.MODULES.CASINO,
    ...(launchedFromModal && { gaEventLabel: AMPLITUDE_EVENTS.LABELS.RM_FIRST_TIME_MODAL })
});

export const getRMWelcomeModalViewedProps = () => ({
    event: AMPLITUDE_EVENTS.EVENTS.RM_WELCOME_MODAL_VIEWED,
    gaEventCategory: AMPLITUDE_EVENTS.CATEGORIES.REWARDS_MACHINE,
    gaEventAction: AMPLITUDE_EVENTS.ACTIONS.CLICKED,
    gaEventLabel: AMPLITUDE_EVENTS.LABELS.RM_FIRST_TIME_MODAL,
    module: AMPLITUDE_EVENTS.MODULES.CASINO
});

export const getRMExitModalViewedProps = () => ({
    event: AMPLITUDE_EVENTS.EVENTS.RM_EXIT_MODAL_VIEWED,
    gaEventCategory: AMPLITUDE_EVENTS.CATEGORIES.REWARDS_MACHINE,
    gaEventAction: AMPLITUDE_EVENTS.ACTIONS.CLICKED,
    module: AMPLITUDE_EVENTS.MODULES.RM_EXIT_MODAL
});

export const getRMInfoModalViewedProps = () => ({
    event: AMPLITUDE_EVENTS.EVENTS.RM_MORE_INFO_MODAL_VIEWED,
    gaEventCategory: AMPLITUDE_EVENTS.CATEGORIES.REWARDS_MACHINE,
    gaEventAction: AMPLITUDE_EVENTS.ACTIONS.CLICKED,
    module: AMPLITUDE_EVENTS.MODULES.RM_MORE_INFO
});
